import React from 'react';
import CTA from '../../pages/home/CtaSection';
import Faq from '../../components/Faq';

const ServiceDetailsManipulatorMain = () => {
  return (
    <main>
      {/* Intro Text Section */}
      <div className="intro-text-section" style={{
        padding: 'clamp(120px, 15vw, 200px) 0 clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontSize: 'clamp(32px, 5vw, 56px)',
            fontWeight: '700',
            color: '#14105B',
            marginBottom: 'clamp(20px, 3vw, 30px)',
            lineHeight: '1.2',
            letterSpacing: '-0.5px'
          }}>
            Avcı Robotik Kol Sistemi
          </h1>
          <p style={{
            fontSize: 'clamp(16px, 2vw, 20px)',
            lineHeight: '1.7',
            color: '#14105B',
            marginBottom: 'clamp(30px, 4vw, 40px)',
            maxWidth: '800px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Avcı, insansız su altı araçları (ROV) ile yürütülen operasyonlarda görev çeşitliliğini artırmak ve insan müdahalesine ihtiyaç duymaksızın karmaşık su altı görevlerini yerine getirmek üzere tasarlanmış, çok fonksiyonlu ve modüler yapıda yüksek hassasiyetli bir robotik kol sistemidir. Kesme, kavrama, kurtarma ve onarım gibi kritik görevler için farklı uç efektörlerle yapılandırılabilen Avcı, derin deniz koşullarına dayanıklı tasarımı ve hassas konumlandırma kabiliyetiyle dışa bağımlılığı azaltan, yerli ve milli bir çözüm sunar.
          </p>
          <a
            href="/iletisim"
            style={{
              display: 'inline-block',
              padding: 'clamp(12px, 1.5vw, 16px) clamp(30px, 4vw, 40px)',
              fontSize: 'clamp(14px, 1.8vw, 18px)',
              fontWeight: '600',
              color: '#14105B',
              backgroundColor: 'transparent',
              border: '1px solid #14105B',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textTransform: 'none',
              letterSpacing: '0.5px',
              textDecoration: 'none'
            }}
          >
            Demo Talep Et
          </a>
        </div>
      </div>

      <div className="middle-wrapper" style={{
        padding: 'clamp(40px, 8vw, 140px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div className="screen-and-text" style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'clamp(30px, 5vw, 80px)',
            flexWrap: 'wrap',
          }}>
            <div className="screen-wrapper" style={{
              flex: '1 1 50%',
              minWidth: 'min(100%, 400px)',
              maxWidth: '700px'
            }}>
              <div className="rec" style={{
                position: 'relative',
                width: '100%',
                backgroundColor: '#f5f5f5',
                borderRadius: 'clamp(12px, 2vw, 20px)',
                padding: 'clamp(6px, 1.2vw, 16px)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: '100%',
                  paddingBottom: '56.25%',
                  position: 'relative',
                  backgroundColor: '#e8e8e8',
                  borderRadius: 'clamp(8px, 1.5vw, 12px)',
                  overflow: 'hidden'
                }}>
                  <img
                    src="/robot_kol_ana.svg"
                    alt="Avcı Robotik Kol Dashboard"
                    style={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="text-wrapper" style={{
              flex: '1 1 40%',
              minWidth: 'min(100%, 300px)',
              maxWidth: '550px',
              paddingTop: '0',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start'
            }}>
              <p className="title wow fadeInUp" style={{
                fontSize: 'clamp(12px, 1.2vw, 15px)',
                color: '#14105B',
                marginBottom: 'clamp(8px, 1.5vw, 16px)',
                fontWeight: '500',
                letterSpacing: '0.3px',
                marginTop: '0'
              }}>
                Kontrol İstasyonu
              </p>
              <h2 className="wow fadeInUp" data-wow-delay=".2s" style={{
                fontSize: 'clamp(20px, 3.5vw, 42px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2.5vw, 24px)',
                lineHeight: '1.2',
                letterSpacing: '-0.3px',
                marginTop: '0'
              }}>
                Kontrol İstasyonu ve <span className="nowrap-text">Dashboard Ekranı</span>
              </h2>
              <p className="wow fadeInUp" data-wow-delay=".4s" style={{
                fontSize: 'clamp(13px, 1.6vw, 17px)',
                lineHeight: '1.65',
                color: '#333333',
                marginBottom: 'clamp(12px, 2vw, 20px)',
                fontWeight: '400',
                marginTop: '0'
              }}>
                Avcı’nın kontrol istasyonu, robotik kolun tüm hareketlerini ve görevlerini tek bir ekrandan kolayca yönetebilmeniz için tasarlanmıştır. Sezgisel arayüz sayesinde operatör, kolun ne yaptığını anlık olarak görür, görev adımlarını güvenle yönlendirir ve sistemin genel durumunu tek bakışta takip edebilir. Böylece karmaşık su altı operasyonları bile daha anlaşılır, yönetilebilir ve kontrollü hale gelir.
              </p>
              <p className="wow fadeInUp" data-wow-delay=".4s" style={{
                fontSize: 'clamp(13px, 1.6vw, 17px)',
                lineHeight: '1.65',
                color: '#333333',
                marginBottom: '0',
                fontWeight: '400',
                marginTop: '0'
              }}>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="items-wrapper" style={{
        padding: 'clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff',
        marginTop: '0'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div className="items-container" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 'clamp(30px, 4vw, 60px)',
            position: 'relative'
          }}>
            {/* Divider lines */}
            <div className="items-divider items-divider-1"></div>
            <div className="items-divider items-divider-2"></div>

            {/* Item 1 */}
            <div className="item one wow fadeInRight" style={{
              padding: '0 clamp(15px, 2vw, 30px)'
            }}>
              <div className="icon-wrapper" style={{
                marginBottom: 'clamp(20px, 3vw, 30px)',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
                {/* SVG görselinizi buraya ekleyin */}
                <img
                  src="/robot-1.svg"
                  alt="Robotik Kol Durum"
                  style={{
                    width: 'clamp(40px, 5vw, 50px)',
                    height: 'auto',
                    flexShrink: 0,
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h3 style={{
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2vw, 18px)',
                lineHeight: '1.3'
              }}>
                Avcı ile Su Altında Birden Fazla Görevi Yönetin
              </h3>
              <p style={{
                fontSize: 'clamp(14px, 1.6vw, 16px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Avcı’nın modüler yapısı ve hızlı uç efektör değişim kabiliyeti sayesinde, aynı sistemle kesme, kavrama, numune toplama, enkazdan parça çıkarma ve ekipman yerleştirme gibi birbirinden farklı su altı görevlerini kolayca yapılandırabilirsiniz.
              </p>
            </div>

            {/* Item 2 */}
            <div className="item two wow fadeInRight" data-wow-delay=".2s" style={{
              padding: '0 clamp(15px, 2vw, 30px)'
            }}>
              <div className="icon-wrapper" style={{
                marginBottom: 'clamp(20px, 3vw, 30px)',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
                {/* SVG görselinizi buraya ekleyin */}
                <img
                  src="/robot-2.svg"
                  alt="Robotik Kol İş Yükü"
                  style={{
                    width: 'clamp(40px, 5vw, 50px)',
                    height: 'auto',
                    flexShrink: 0,
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h3 style={{
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2vw, 18px)',
                lineHeight: '1.3'
              }}>
                Dalgıç Yükünü Azaltın
              </h3>
              <p style={{
                fontSize: 'clamp(14px, 1.6vw, 16px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Zorlu, derin ve riskli bölgelerdeki müdahaleleri Avcı’ya devrederek dalgıç ihtiyacını azaltır, operatörün yalnızca güvenli alandan sistemi yönetmesini sağlarsınız. Böylece hem insan kaynağınızı daha verimli kullanır hem de operasyon sırasında maruz kalınan fiziksel riskleri düşürürsünüz.
              </p>
            </div>

            {/* Item 3 */}
            <div className="item three wow fadeInRight" data-wow-delay=".4s" style={{
              padding: '0 clamp(15px, 2vw, 30px)'
            }}>
              <div className="icon-wrapper" style={{
                marginBottom: 'clamp(20px, 3vw, 30px)',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
                {/* SVG görselinizi buraya ekleyin */}
                <img
                  src="/robot-3.svg"
                  alt="Robotik Kol Otomasyon"
                  style={{
                    width: 'clamp(40px, 5vw, 50px)',
                    height: 'auto',
                    flexShrink: 0,
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h3 style={{
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2vw, 18px)',
                lineHeight: '1.3'
              }}>
                Su Altı Görevlerini Eksiksiz Yürütün
              </h3>
              <p style={{
                fontSize: 'clamp(14px, 1.6vw, 16px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Avcı’nın hassas hareket kabiliyeti ve kaydedilebilir görev senaryoları sayesinde, tekrar eden su altı operasyonlarını her seferinde aynı doğruluk ve kaliteyle uygulayabilirsiniz. Bu da özellikle bakım, numune alma ve inceleme görevlerinde sonuçların karşılaştırılabilir ve güvenilir olmasını sağlar.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Section 1: Çalışma alanı ve erişim */}
      <div className="feature-section-1" style={{
        padding: 'clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'clamp(40px, 6vw, 80px)',
            alignItems: 'center'
          }}>
            {/* Left: Text */}
            <div className="text-part">
              <h3 style={{
                fontSize: 'clamp(24px, 3.5vw, 36px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(16px, 2.5vw, 24px)',
                lineHeight: '1.2'
              }}>
                Genel Teknik Özellikler
              </h3>
              <p style={{
                fontSize: 'clamp(15px, 1.8vw, 18px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Avcı robotik kol, derin deniz koşullarında güvenle görev yapabilmesi için hafif gövde yapısı, yüksek dayanımı ve hassas çok eksenli hareket kabiliyetiyle tasarlanmıştır. Yan tarafta yer alan temel teknik değerler; sistemin erişebildiği mesafeleri, çalışma süresini, hız ve taşıma kapasitesini özetleyerek Avcı’nın su altı operasyonlarında sunduğu genel performans profilini ortaya koyar.
              </p>
            </div>

            {/* Right: Genel Özellik Listesi */}
            <div className="diagram-part" style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              alignItems: 'flex-start',
              width: '100%'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <strong style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B', minWidth: '160px' }}>Ağırlık</strong>
                <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>15 kg</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <strong style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B', minWidth: '160px' }}>Uzama Kapasitesi</strong>
                <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>1000 mm</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <strong style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B', minWidth: '160px' }}>Çalışma Mesafesi</strong>
                <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>500 m</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <strong style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B', minWidth: '160px' }}>Operasyon Süresi</strong>
                <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>5 saat</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <strong style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B', minWidth: '160px' }}>Hareket Hızı</strong>
                <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>45°/s</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <strong style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B', minWidth: '160px' }}>Taşıma Kapasitesi</strong>
                <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>40 kg</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Section 2: Güvenlik ve çarpışma önleme */}
      <div className="feature-section-2" style={{
        padding: 'clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'clamp(40px, 6vw, 80px)',
            alignItems: 'center'
          }}>
            {/* Left: Alert Visual / Ekran */}
            <div className="alert-visual-part" style={{
              position: 'relative',
              width: '100%',
              maxWidth: '500px',
              borderRadius: '12px',
              overflow: 'hidden',
              backgroundColor: '#f5f5f5'
            }}>
              <img
                src="/Gemasan_Robotik_Kol_Yeni.gif"
                alt="Ship detection"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  borderRadius: '12px'
                }}
              />
            </div>

            {/* Right: Text */}
            <div className="text-part">
              <h3 style={{
                fontSize: 'clamp(24px, 3.5vw, 36px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(16px, 2.5vw, 24px)',
                lineHeight: '1.2'
              }}>
                Avcı ile Güvenli ve Kontrollü Operasyon
              </h3>
              <p style={{
                fontSize: 'clamp(15px, 1.8vw, 18px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Avcı robotik kol, su altı görevlerinde gemi mürettebatının uzanan eli gibi çalışır. Yüksek hassasiyetli hareket kabiliyeti sayesinde enkazdan parça çıkarma, boru veya halat kesme, vanaları açıp kapama, sensör yerleştirme ve ekipman kurtarma gibi çok farklı görevleri tek bir platform üzerinden yerine getirir. Değiştirilebilir uç efektörleri ile çeşitli kavrama ve kesme ihtiyaçlarına hızla uyum sağlar; böylece bakım, onarım ve müdahale süreçleri daha hızlı, esnek ve güvenilir hale gelir.
              </p>
            </div>
          </div>
        </div>
      </div>

      <CTA />
    </main>
  );
};

export default ServiceDetailsManipulatorMain;
